import React from 'react';
import { View } from 'react-native';
import Text from '~/components/Text';

export interface ServicePriceCardProps {
  value: string;
}

const ServicePriceCard: React.FC<ServicePriceCardProps> = ({ value }) => {
  return (
    <View className="mb-6 p-4 rounded-md border border-primary-600">
      <View className="flex-row justify-between items-center w-full">
        <Text className="text-primary-600">Por apenas:</Text>
        <Text className="text-primary-600 text-sm">
          R$<Text className="font-medium text-xl">{value}</Text>
          /mês
        </Text>
      </View>
    </View>
  );
};

export default ServicePriceCard;
